import { CSSObject, styled } from '@mui/material/styles';
import {
  Link as ReactRouterLink,
  NavLink as ReactRouterNavLink,
} from 'react-router-dom';

export const Link = styled(ReactRouterLink)(() => ({
  color: 'rgba(1, 128, 148, 1)',
  textDecoration: 'none',
  fontWeight: '600',
  lineHeight: '18.2px',
  fontSize: '14px',
  fontFamily: 'Sarabun',

  '&:hover': {
    color: 'rgba(7, 87, 100, 1)',
  },
}));

interface SidebarLinkProps {
  collapsed?: boolean;
}

const sidebarDrawerItemStyles = (collapsed?: boolean): CSSObject => ({
  display: 'flex',
  gap: collapsed ? '0' : '8px',
  alignItems: 'center',
  justifyContent: collapsed ? 'center' : 'flex-start',
  fontFamily: 'Sarabun',
  fontSize: '14px',
  lineHeight: '18px',
  textDecoration: 'none',
  color: 'rgba(255, 255, 255, 0.85)',
  fontWeight: 500,
  padding: collapsed ? '12px 0' : '10px 0',
  borderRadius: '6px',
  transition: 'all 0.2s ease',
  minHeight: collapsed ? '44px' : '40px',
  width: '100%',
  position: 'relative',

  '&:hover, &.active, &[data-nav-active="true"]': {
    color: 'rgba(30, 237, 159, 1)',
    backgroundColor: collapsed ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
  },

  '& .MuiSvgIcon-root': {
    fontSize: collapsed ? '24px' : '20px',
    flexShrink: 0,
    width: collapsed ? '24px' : '20px',
    height: collapsed ? '24px' : '20px',
  },

  // Nascondi completamente il testo quando collassato
  '& > span, & > *:not(.MuiSvgIcon-root):not(svg)': {
    display: collapsed ? 'none' : 'inline',
  },
});

export const NavLink = styled(ReactRouterNavLink, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<SidebarLinkProps>(({ collapsed }) => sidebarDrawerItemStyles(collapsed));

/** `Link` con stessi stili della sidebar: attivo via `data-nav-active="true"` (query-aware), non solo pathname. */
export const SidebarDrawerLink = styled(ReactRouterLink, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<SidebarLinkProps>(({ collapsed }) => sidebarDrawerItemStyles(collapsed));
